export default __webpack_public_path__ + "static/media/cat.2950d234.svg";